import { Alert, Box, Button, Container, Grid, Link, TextField, Typography } from '@mui/material';
import React from 'react';
import emailjs from 'emailjs-com'
import { NavLink } from 'react-router-dom';
import logo from '../../../images/footer-logo.png';
import './ContactForm.css';
import { useState } from 'react';

const ContactForm = () => {
    const [success, setSuccess] = useState();
    function sendEmail(e) {
        e.preventDefault();

        emailjs.sendForm('service_vqt4zj8', 'template_omdzdwn', e.target, 'user_o9SzaWXmr6drzM5gws1Bt')
            .then(res => {
                setSuccess(<Alert severity="success">Your Form has been successfully submitted.</Alert>);
            }).catch(err => {
                setSuccess(err);
            })
    }
    return (
        <div>
            <Container>
                <Box sx={{ my: 3, p: 3, backgroundColor: '#ffffff', borderRadius: 1, boxShadow: '0px 0px 15px rgba(167, 167, 168, 0.83)' }} id="display-box">
                    <Grid container>
                        <Grid item sx={{ pr: 3, my: 'auto' }} xs={12} md={8}>
                            <Typography sx={{ m: 1, pb: 2, pl: 4, marginX: 'auto', fontWeight: 600, textAlign: 'left', color: '#000D83' }} id="form-head" variant="h4" display="block" gutterBottom>
                                Get In Touch
                            </Typography>
                            <form onSubmit={sendEmail}>
                                <TextField
                                    required
                                    className="text-field"
                                    sx={{ my: 1, mx: 2, backgroundColor: "#F2F2FF", borderRadius: 2 }}
                                    label="Your Name"
                                    type="text"
                                    name="name"
                                />
                                <TextField
                                    required
                                    className="text-field"
                                    sx={{ my: 1, mx: 2, backgroundColor: "#F2F2FF", borderRadius: 2 }}
                                    id="outlined-basic"
                                    label="Company Name"
                                    type="text"
                                    name="company"
                                />
                                <TextField
                                    className="text-field"
                                    sx={{ my: 1, mx: 2, backgroundColor: "#F2F2FF", borderRadius: 2 }}
                                    id="outlined-basic"
                                    label="Your Email"
                                    type="email"
                                    name="personal-email"
                                    required
                                />
                                <TextField
                                    className="text-field"
                                    sx={{ my: 1, mx: 2, backgroundColor: "#F2F2FF", borderRadius: 2 }}
                                    id="outlined-basic"
                                    label="Company Email"
                                    type="text"
                                    name="company-email"
                                    required
                                />
                                <TextField
                                    required
                                    className="text-message"
                                    sx={{ my: 1, mx: 2, backgroundColor: "#F2F2FF", borderRadius: 2 }}
                                    id="outlined-basic"
                                    label="Your requirement in brief"
                                    type="text"
                                    name="message"
                                    multiline
                                    rows={4}
                                />
                                <br />
                                <Box id="button-position" sx={{ pl: 4 }}>
                                    <Button sx={{ mt: 3, fontSize: '16px', textTransform: 'capitalize', px: 4 }} type="submit" style={{ color: 'white', backgroundColor: '#FF2D33' }}>Submit</Button>
                                </Box>
                            </form>
                        </Grid>
                        <Grid item sx={{ backgroundColor: '#000D83', borderRadius: 1 }} id="grid-display" xs={12} md={4}>
                            <NavLink to="/" >
                                <img style={{ width: '192px', paddingTop: '25px' }} src={logo} alt="" />
                            </NavLink>
                            <Box sx={{ textAlign: 'left', pt: 4 }}>
                                <Typography sx={{ m: 1, pb: 2, pl: 4, marginX: 'auto' }} style={{ color: '#ffffff', fontSize: '24px' }} variant="h6" display="block" gutterBottom>
                                    Contact Us
                                </Typography>
                                <Typography sx={{ m: 1, pl: 3 }} style={{ color: '#f0f0f0' }}>
                                    <i style={{ paddingRight: '10px' }} className="fas fa-phone-alt"></i> +01 2424242424
                                </Typography>
                                <Typography sx={{ mx: 1, my: 3, pl: 3 }} style={{ color: '#f0f0f0' }}>
                                    <i style={{ paddingRight: '10px' }} className="fas fa-envelope"></i> email@email.com
                                </Typography>
                                <Typography sx={{ m: 1, pl: 3 }} style={{ color: '#f0f0f0' }}>
                                    <i style={{ paddingRight: '10px' }} className="fas fa-map-marker-alt"></i> level 2,1284 South Road, <br /><span style={{ paddingLeft: '27px' }}>Tonsley South Australia 5042</span>
                                </Typography>
                            </Box>
                            <Box sx={{ py: 4 }}>
                                <Typography sx={{ m: 1, width: '75%', marginX: 'auto' }} style={{ color: '#ffffff', fontSize: '20px' }} variant="h6" display="block" gutterBottom>
                                    Find us On
                                </Typography>
                                <Typography sx={{ mt: 2, width: '75%', marginX: 'auto' }} >
                                    < Link style={{ color: '#ffffff', margin: '10px', fontSize: '30px' }} href="#"><i className="fab fa-dribbble"></i></ Link>
                                    < Link style={{ color: '#ffffff', margin: '10px', fontSize: '30px' }} href="#"><i className="fab fa-behance"></i></ Link>
                                    < Link style={{ color: '#ffffff', margin: '10px', fontSize: '30px' }} href="#"><i className="fab fa-instagram"></i></ Link>
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {
                    success && <Grid sx={{ width: "75%", margin: "auto" }}>
                        <Typography style={{ textAlign: 'start' }} variant="caption" display="block" gutterBottom>{success}</Typography>
                    </Grid>
                }
            </Container>
        </div>
    );
};

export default ContactForm;